/**
 * Debug Configuration
 * Set DEBUG_MODE to false for production builds
 */

export const DEBUG_MODE = false;

export function debugLog(...args) {
  if (DEBUG_MODE) {
    console.log(...args);
  }
}

export function debugError(...args) {
  if (DEBUG_MODE) {
    console.error(...args);
  }
}

export function debugWarn(...args) {
  if (DEBUG_MODE) {
    console.warn(...args);
  }
}
